import { createRoute, dynamicWrapper } from '@/utils/core';

const routesConfig = (app) => ({
    path: '/HiddenDanger/index',
    title: '隐患管理',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
